/** Rugby match officiating — minimum hiring charges (KES). Keep in sync with backend match.py */
export const FIRST_OFFICIAL_MIN_HIRE_KES = 2000;
export const ADDITIONAL_OFFICIAL_MIN_HIRE_KES = 1000;
export const RUGBY_MAX_OFFICIATING_SLOTS = 4;

export const OFFICIATING_COUNT_OPTIONS = [
  {
    count: 1,
    label: "1 Official",
    summary: "Referee only — common for 7s",
    icon: "fa-solid fa-user-shield",
    maxFormat: "15s",
  },
  {
    count: 2,
    label: "2 Officials",
    summary: "Referee + 1 assistant referee",
    icon: "fa-solid fa-flag",
    maxFormat: "15s",
  },
  {
    count: 3,
    label: "3 Officials",
    summary: "Referee + 2 assistant referees",
    icon: "fa-solid fa-people-group",
    maxFormat: "15s",
  },
  {
    count: 4,
    label: "4 Officials",
    summary: "Full crew incl. TMO",
    icon: "fa-solid fa-display",
    maxFormat: "15s",
  },
];

export const OFFICIATING_SLOTS = [
  {
    slot: 1,
    label: "Referee",
    role: "Primary match referee",
    icon: "fa-solid fa-user-shield",
  },
  {
    slot: 2,
    label: "Assistant Referee 1",
    role: "Touch judge / sideline",
    icon: "fa-solid fa-flag",
  },
  {
    slot: 3,
    label: "Assistant Referee 2",
    role: "Touch judge / sideline",
    icon: "fa-solid fa-flag",
  },
  {
    slot: 4,
    label: "TMO",
    role: "Television match official",
    icon: "fa-solid fa-display",
  },
];

const FORMAT_MAX_OFFICIALS = {
  "7s": 2,
  "10s": 3,
  "15s": 4,
};

export function officiatingSlotMinimumKes(slotNumber) {
  if (slotNumber <= 0) return 0;
  if (slotNumber === 1) return FIRST_OFFICIAL_MIN_HIRE_KES;
  return ADDITIONAL_OFFICIAL_MIN_HIRE_KES;
}

export function officiatingMinimumCostKes(slotsRequested) {
  if (!slotsRequested || slotsRequested <= 0) return 0;
  const capped = Math.min(Number(slotsRequested), RUGBY_MAX_OFFICIATING_SLOTS);
  let total = 0;
  for (let slot = 1; slot <= capped; slot += 1) {
    total += officiatingSlotMinimumKes(slot);
  }
  return total;
}

export function formatKes(amount) {
  return `KSh ${Number(amount).toLocaleString("en-KE")}`;
}

export function activeOfficiatingSlots(count) {
  if (!count || count <= 0) return [];
  return OFFICIATING_SLOTS.slice(0, Math.min(count, OFFICIATING_SLOTS.length));
}

export function defaultOfficiatingCountForFormat(matchFormat) {
  if (matchFormat === "7s") return 1;
  if (matchFormat === "10s") return 2;
  if (matchFormat === "15s") return 3;
  return 2;
}

export function officiatingCountOptionsForFormat(matchFormat) {
  const max = FORMAT_MAX_OFFICIALS[matchFormat] || RUGBY_MAX_OFFICIATING_SLOTS;
  return OFFICIATING_COUNT_OPTIONS.filter((opt) => opt.count <= max);
}

export function officiatingFormatHint(matchFormat) {
  if (matchFormat === "7s") {
    return "Rugby 7s typically uses one referee; two officials for higher-level fixtures.";
  }
  if (matchFormat === "10s") {
    return "Rugby 10s usually needs a referee plus one or two assistant referees.";
  }
  if (matchFormat === "15s") {
    return "Rugby 15s standard is three officials (ref + 2 ARs); add TMO for full crew.";
  }
  return "Select your match format above to see recommended officiating options.";
}
